import { render, staticRenderFns } from "./points_task_Invite.vue?vue&type=template&id=f30cbb02&scoped=true"
import script from "./points_task_Invite.vue?vue&type=script&lang=js"
export * from "./points_task_Invite.vue?vue&type=script&lang=js"
import style0 from "./points_task_Invite.vue?vue&type=style&index=0&id=f30cbb02&prod&lang=scss&scoped=true"
import style1 from "./points_task_Invite.vue?vue&type=style&index=1&id=f30cbb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30cbb02",
  null
  
)

export default component.exports